import ScrollTable from './ScrollTable'
export default ScrollTable
